<template>
  <div>
    {{ materialTypeFullName }}
  </div>
</template>

<script>
export default {
  name: 'MaterialTypeRenderer',
  data() {
    return {
      materialType: null,
      materialSubTypeId: null
    }
  },
  computed : {
    materialTypeFullName() {
      if (this.materialType === null) {
        return ""
      }
      else if (this.materialSubTypeId === null) {
        return this.$t("Material." + this.materialType)
      }
      else {
        const subType = this.$store.state.gradeControl.materialSubTypes.find(m => m.materialSubTypeId === this.materialSubTypeId);
        return this.$t("Material." + this.materialType) + "-" +  subType.name;
      }
    }
  },
  created() {
    this.materialType = this.params.value.materialType;
    this.materialSubTypeId = this.params.value.materialSubTypeId;
  }
}
</script>
